/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type {
  VaultFactory,
  VaultFactoryInterface,
} from "../../contracts/VaultFactory";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "adapterTypeId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "adapter",
        type: "address",
      },
    ],
    name: "AdapterCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
    ],
    name: "AdapterTypeAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "revoker",
        type: "address",
      },
    ],
    name: "AdapterTypeRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "defaultDepositTolerance",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "setter",
        type: "address",
      },
    ],
    name: "DefaultDepositToleranceSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "feeBps",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "setter",
        type: "address",
      },
    ],
    name: "FeeBpsSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "feeReceiver",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "setter",
        type: "address",
      },
    ],
    name: "FeeReceiverSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "vaultId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "vaultTypeId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "adapter",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "vault",
        type: "address",
      },
    ],
    name: "VaultCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "adapter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fixedSideCapacity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "variableSideCapacity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "variableAsset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "feeBps",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "feeReceiver",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "vault",
        type: "address",
      },
    ],
    name: "VaultInitialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
    ],
    name: "VaultTypeAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "revoker",
        type: "address",
      },
    ],
    name: "VaultTypeRevoked",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "adapterTypeByteCode",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "bytecode",
        type: "bytes",
      },
    ],
    name: "addAdapterType",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "bytecode",
        type: "bytes",
      },
    ],
    name: "addVaultType",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "adapterTypeId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "poolAddress",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "createAdapter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_vaultTypeId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_adapterAddress",
        type: "address",
      },
    ],
    name: "createVault",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "defaultDepositTolerance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "deployedAdapterAddrToId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "deployedAdapterInfo",
    outputs: [
      {
        internalType: "uint256",
        name: "adapterTypeId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "creatorAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeBps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeReceiver",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "vaultId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "fixedSideCapacity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "variableSideCapacity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "duration",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "variableAsset",
        type: "address",
      },
    ],
    name: "initializeVault",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nextAdapterTypeId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextDeployedAdapterId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextVaultId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextVaultTypeId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "revokeAdapterType",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "revokeVaultType",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_defaultDepositTolerance",
        type: "uint256",
      },
    ],
    name: "setDefaultDepositTolerance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_feeBps",
        type: "uint256",
      },
    ],
    name: "setFeeBps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_feeReceiver",
        type: "address",
      },
    ],
    name: "setFeeReceiver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "vaultAddrToId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "vaultInfo",
    outputs: [
      {
        internalType: "address",
        name: "creatorAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "address",
        name: "adapterAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "vaultTypeId",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "vaultTypeByteCode",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "wasDeployedByFactory",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type VaultFactoryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: VaultFactoryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class VaultFactory__factory extends ContractFactory {
  constructor(...args: VaultFactoryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<VaultFactory> {
    return super.deploy(overrides || {}) as Promise<VaultFactory>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): VaultFactory {
    return super.attach(address) as VaultFactory;
  }
  override connect(signer: Signer): VaultFactory__factory {
    return super.connect(signer) as VaultFactory__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): VaultFactoryInterface {
    return new utils.Interface(_abi) as VaultFactoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): VaultFactory {
    return new Contract(address, _abi, signerOrProvider) as VaultFactory;
  }
}
